import BaseModel from "./BaseModels/BaseModel"

export class DNSSuffix extends BaseModel {
  dns_suffix?: string
}